import React from "react"

import { FEATURES_TYPE } from "@constants"
import AppLayout from "Layout"
import { BUSINESS_LOGISTICS_ROUTES } from "@constants/routes"
import EuropcarAnalyticsPage from "./Analytics/Page";
import BIPage from "./BI/Page";
import SeasonVsLastYearPage from "./Dashboards/SeasonVsLastYear/Page";
import PriceCurvePage from "./Dashboards/PriceCurve/Page";
import OfficeNetworkPage from "./Dashboards/OfficeNetwork/Page";
import { Navigate } from "react-router-dom";
import { businessLogisticsChildren, businessLogisticsRedirects, leadingRetiredRoute, pricingEnvironmentNote, sectionIndexPath, MENU_KEYS } from "./@services/menu";
import LeadingRetired from "./LeadingRetired";
import MovedNote from "./@components/MovedNote";


// The page of each menu entry; the order and the flags live in `@services/menu.js` (CU-869fmhmx8 D13)
const ELEMENTS = {
	[MENU_KEYS.SEASON_VS_LY]: <SeasonVsLastYearPage/>,
	[MENU_KEYS.PRICE_CURVE]: <PriceCurvePage/>,
	[MENU_KEYS.OFFICE_NETWORK]: <OfficeNetworkPage/>,
	[MENU_KEYS.EUROPCAR]: <EuropcarAnalyticsPage/>,
	[MENU_KEYS.ADVANCED]: <BIPage/>,
}

export const BusinessLogisticsRoutes = userData => {
	const features = userData?.featuresV2 || {}
	const children = businessLogisticsChildren(features, BUSINESS_LOGISTICS_ROUTES, { today: new Date() })
		.map(({ key, path, title, badge, noMenu }) => ({ path, title, element: ELEMENTS[key], ...(badge && { badge }), ...(noMenu && { noMenu }) }))
	// reachable, never listed (CA 22: the old Pricing Environment address opens Week by week)
	const redirects = businessLogisticsRedirects(features, BUSINESS_LOGISTICS_ROUTES)
		.map(({ path, to }) => ({ path, noMenu: true, element: <Navigate to={to} replace/> }))

	// Leading Analyzer's old address, off the menu (no `id`), with its own layout: a user with only `leading_price` has
	// no Business Intelligence section any more (CU-869fmjzrh R)
	const leading = leadingRetiredRoute(features)
	const retired = leading ? [{
		path: BUSINESS_LOGISTICS_ROUTES.LEADING_ANALYZER_PATH,
		element: <AppLayout/>,
		children: [{ index: true, element: <LeadingRetired mode={leading}/> }],
	}] : []
	// Pricing Environment's old address without `bi`: a note that it moved, never a 404 (CU-869fmjzrg CA 22c, Curro
	// 2026-10-27, B). With `bi` the address is a redirect inside the section (`businessLogisticsRedirects`)
	if (pricingEnvironmentNote(features)) retired.push({
		path: BUSINESS_LOGISTICS_ROUTES.PRICING_ENV_PATH,
		element: <AppLayout/>,
		children: [{ index: true, element: <MovedNote name="Pricing Environment" replacement={<><b>Price curve of a date</b> › <b>Week by week</b></>}/> }],
	})

	if (children.length > 0) {
		// The header opens Advanced (BI) with `bi`, else the first entry listed (Curro's decision 6). With nothing listed
		// (e.g. `europcar` alone: Europcar is listed under Main Page, Pricing Environment is retired) the section keeps
		// routing its children but is not drawn, so the menu never shows an empty "Business Intelligence" header
		const index = sectionIndexPath(features, BUSINESS_LOGISTICS_ROUTES)
		return [...retired, {
			id: FEATURES_TYPE.COMMON,
			path: BUSINESS_LOGISTICS_ROUTES.PATH,
			title: BUSINESS_LOGISTICS_ROUTES.TITLE,
			icon: 'chart-line',
			element: <AppLayout/>,
			...(!index && { noMenu: true }),
			children: [
				...(index ? [{ element: <Navigate to={index} replace/>, index: true }] : []),
				...children, ...redirects,
			]
		}]
	}

	return retired
}
